(function() {
	
	/**
	 * Dialog that is displayed after adding an item to the shopping cart.
	 */
	var AddToCart = function(form) {
		var self = this;
		this.form = form;
		$(form).on('submit', function(evt) {
			self.submit(evt);
		});
	};
	
	AddToCart.prototype = {
		submit: function(evt) {
			var form = $(this.form);
			evt.preventDefault();
			$('#add_to_cart_dialog .modal-dialog').html('');
			$('#add_to_cart_dialog').modal();
			var postBody = 'dialog=1&' + form.serialize();
			$.post(form.attr('action'), postBody).done(function(res) {
				$('#add_to_cart_dialog .modal-dialog').html(res);
			});
		}
	};

	C.AddToCart = AddToCart;

})();